import { FormEngineModeTypeEnum } from '@celito.clients/enums';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { ControlledDocumentPreviewPageProps } from './controlled-document-preview-page.model';
import { ControlledDocumentPreviewPageView } from './controlled-document-preview-page.view';

interface ControlledDocumentPreviewPageControllerProps
  extends ControlledDocumentPreviewPageProps {}

export const ControlledDocumentPreviewPageController = (
  props: ControlledDocumentPreviewPageControllerProps
): JSX.Element => {
  const { watch } = useFormContext() || {};

  let recordDetails = props.recordDetails;

  if (props.mode !== FormEngineModeTypeEnum.View) {
    const formValues = watch?.();

    recordDetails = {};
    props.attributeConfig.objectAttributeDefinitions?.forEach((item) => {
      recordDetails![item.columnName] = formValues?.[item.name];
    });
  }

  useEffect(() => {
    if (props.mode === FormEngineModeTypeEnum.View) {
      return;
    }

    props.setWizardStepsState((prev) =>
      prev.map((prevStep) =>
        prevStep.number === props.step
          ? { ...prevStep, isValid: true }
          : prevStep
      )
    );
  }, []);

  return (
    <ControlledDocumentPreviewPageView
      {...props}
      onSave={props.onSave}
      recordDetails={recordDetails}
    />
  );
};
